import React, { useState } from 'react';
import {
  Modal,
  Text,
  PaymentMethodFormWithMicrodepositsProps,
  Crate,
  Skeleton,
} from '@perch-labs/shrike';
import { copyFor, routes } from 'config';
import { getFullUrl } from 'utils/format';
import { trackClickEvent } from 'domain/tracking';
import { StyledPaymentMethodForm } from './add-payment-method.style';

type ShrikePaymentCopy = Pick<
  PaymentMethodFormWithMicrodepositsProps,
  'copy'
>['copy'];

const getCopy = copyFor(
  'settings.paymentInformation.addPaymentMethodModal.screens.addPaymentMethod'
);
interface Props {
  context: AddPaymentMethodContext;
  close: () => void;
  next: () => void;
  matches: (state: string) => boolean;
}

export const AddPaymentMethod = ({ next, close, context, matches }: Props) => {
  const [ready, setReady] = useState(false);
  const { stripeClientSecret } = context;

  return (
    <>
      <Modal.Header title={getCopy('title')} onClose={close} />
      <Modal.Content>
        <Text margin={{ bottom: '24px' }}>{getCopy('subtitle')}</Text>
        {!ready && (
          <Crate padding="16px 0" dataAttributes={{ testid: 'add-loading' }}>
            {[...Array(2).keys()].map(num => (
              <React.Fragment key={`skeleton-${num}`}>
                <Skeleton
                  width="100%"
                  height="32px"
                  margin={{ bottom: '8px' }}
                />
                <Skeleton
                  width="100%"
                  height="24px"
                  margin={{ bottom: '32px' }}
                />
              </React.Fragment>
            ))}
          </Crate>
        )}
        {stripeClientSecret && (
          <StyledPaymentMethodForm
            copy={
              { submit: getCopy('buttons.addAndContinue') } as ShrikePaymentCopy
            }
            onCancel={() => {
              trackClickEvent('paymentInformation.addPaymentModal.cancel');
              close();
            }}
            onReady={() => setReady(true)}
            onSubmit={() => next()}
            ready={ready}
            stripeKey={process.env.ARCADIA_STRIPE_KEY || ''}
            stripeClientSecret={stripeClientSecret}
            // Using prop below to access new payment form but not actually allowing microdeposits
            allowMicrodeposits
            loading={matches('addPaymentMethod.pollForPaymentCreation')}
            redirectUrl={getFullUrl(routes().payment)}
          >
            {context.shouldCreatePaymentHold && (
              <Text
                textStyle="paragraph500"
                opacity="medium"
                margin={{ top: '8px', bottom: '0' }}
              >
                {getCopy('paymentHoldCallout')}
              </Text>
            )}
          </StyledPaymentMethodForm>
        )}
      </Modal.Content>
    </>
  );
};
